import { ScrollView } from "dripsy";
import * as React from "react";
import type { ScrollViewProps } from "react-native";
import { useSafeArea } from "@provider/safe-area/use-safe-area";
import { useIsFocused } from "react-native-ridge-navigation";
import { KeyboardAvoidingView, Platform, StyleSheet } from "react-native";

type DripsyProps = React.ComponentProps<typeof ScrollView>;
type Props = ScrollViewProps & {
  automaticallyAdjustKeyboardInsets?: boolean;
  contentContainerSx?: DripsyProps["contentContainerSx"];
  sx?: DripsyProps["sx"];
  avoidKeyboard?: boolean;
};
function ScreenScrollView({ style, avoidKeyboard, ref, ...props }: Props & { ref?: React.Ref<any> }) {
  const insets = useSafeArea();
  const isFocused = useIsFocused();
  const inner = (
    <ScrollView
      ref={ref}
      {...props}
      keyboardShouldPersistTaps="handled"
      style={[{ flex: 1 }, style]}
      contentContainerStyle={{
        paddingBottom: insets.bottom,
      }}
      automaticallyAdjustContentInsets={false}
      automaticallyAdjustKeyboardInsets={false}
    />
  );
  if (avoidKeyboard && Platform.OS !== "web") {
    return (
      <KeyboardAvoidingView
        key={isFocused ? "focused" : "not-focused"}
        keyboardVerticalOffset={0}
        behavior="padding"
        style={styles.avoidingKeyboard}
        contentContainerStyle={styles.contentContainerStyle}
      >
        {inner}
      </KeyboardAvoidingView>
    );
  }
  return inner;
}

const styles = StyleSheet.create({
  contentContainerStyle: {
    flexGrow: 1,
  },
  avoidingKeyboard: {
    flex: 1,
    padding: 0,
    margin: 0,
  },
});

export default ScreenScrollView;
